<template>
    <div>
        <v-container>
            <v-card>
                <v-card-text>
                    <v-row>
                        <v-col class="teal lighten-2 font-weight-bold">Vendor</v-col>
                        <v-col v-if="dokumenKualifikasi" class="teal lighten-2 font-weight-bold">Dokumen Kualifikasi</v-col>
                        <v-col v-if="kualifikasi" class="teal lighten-2 font-weight-bold">Kualifikasi</v-col>
                        <v-col v-if="administrasi" class="teal lighten-2 font-weight-bold">Administrasi</v-col>
                        <v-col v-if="(bobotTeknis || teknis || nilaiTeknis)" class="teal lighten-2 font-weight-bold">Teknis</v-col>
                        <v-col v-if="bobotBiaya || nilaiPenawaran || biaya || nilaiBiaya" class="teal lighten-2 font-weight-bold">Biaya</v-col>
                        <v-col v-if="totalNilai" class="teal lighten-2 font-weight-bold">Total Nilai</v-col>
                        <v-col v-if="pemenang" class="teal lighten-2 font-weight-bold">Urutan Menang</v-col>
                    </v-row>

                    <v-divider />
                    
                    <template v-for="item in listEvaluasi">
                        <v-row :key="item.id + '_vendor'">
                            <v-col align-self="center" class="font-weight-bold"> {{ item.nama }} </v-col>
                            <v-col align-self="center" v-if="dokumenKualifikasi"> <v-checkbox v-model="item.hasilKualifikasi" :label="item.hasilKualifikasi ? 'Lulus' : 'Tidak Lulus'" :readonly="readonly" /> </v-col>
                            <v-col align-self="center" v-if="kualifikasi"> <v-checkbox v-model="item.lulusKualifikasi" :label="item.lulusKualifikasi ? 'Lulus' : 'Tidak Lulus'" :readonly="readonly" /> </v-col>
                            <v-col align-self="center" v-if="administrasi"> <v-checkbox v-model="item.hasilAdministrasi" :label="item.hasilAdministrasi ? 'Lulus' : 'Tidak Lulus'" :readonly="readonly" /> </v-col>

                            <!-- TEKNIS -->
                            <v-col>
                                <v-text-field v-if="bobotTeknis" label="Bobot Teknis" v-model="paket.bobotTeknis" type="number" suffix="%" outlined readonly />
                                <v-text-field v-if="passingGrade" label="Passing Grade" v-model="paket.passingGrade" type="number" suffix="%" outlined readonly />
                                <v-text-field v-if="teknis" label="Teknis" v-model="item.hasilTeknis" type="number" outlined :readonly="readonly" />
                                <v-text-field v-if="nilaiTeknis" label="Nilai Teknis" :value="getNilaiTeknis(item)" outlined readonly/>
                            </v-col>

                            <!-- BIAYA -->
                            <v-col>
                                <v-text-field v-if="bobotBiaya" label="Bobot Biaya" v-model="paket.bobotHarga" suffix="%" outlined readonly />
                                <text-field-rupiah v-if="nilaiPenawaran" label="Penawaran Terkoreksi" v-model="item.nilaiPenawaran" outlined :readonly="readonly" />
                                <v-text-field v-if="biaya" label="Biaya" v-model="item.hasilHarga" type="number" outlined :readonly="readonly" />
                                <v-text-field v-if="nilaiBiaya" label="Nilai Biaya" :value="getNilaiBiaya(item)" outlined readonly/>
                            </v-col>

                            <!-- TOTAL NILAI -->
                            <v-col v-if="totalNilai"> <v-text-field label="Total Nilai" :value="getTotalNilai(item)" outlined readonly /> </v-col>

                            <!-- PEMENANG -->
                            <v-col v-if="pemenang"> <v-text-field v-model="item.urutan" type="number" outlined :readonly="readonly" /> </v-col>
                        </v-row>
                        <v-divider :key="item.id + '_div'" />
                    </template>

                    <v-row>            
                        <v-col> <v-btn v-if="!readonly" color="green" dark @click="simpanEvaluasi()">Simpan Evaluasi</v-btn> </v-col>            
                    </v-row>
                </v-card-text>
            </v-card>
        </v-container>

        <!-- Notification -->
        <v-snackbar
            v-model="notification.show"
            :color="notification.color"
            :top="true"
            :right="true"
            :timeout=3000
        >
            {{notification.text}}
        </v-snackbar>

        <v-dialog v-model="submitting" persistent max-width="300px">
            <v-card dark>
                <v-card-title>Sedang diproses</v-card-title>
                <v-card-text> <v-progress-linear color="cyan" indeterminate /> </v-card-text>
            </v-card>
        </v-dialog>

    </div>
</template>


<script>
const axios = require('axios').default;
const apiUrl = process.env.VUE_APP_ROOT_API;
import TextFieldRupiah from "./../TextFieldRupiah.vue";


export default {
    components: {
        "text-field-rupiah": TextFieldRupiah
    },

    props: {
        dokumenKualifikasi: {
            type: Boolean, 
            default: false
        },
        kualifikasi: {
            type: Boolean, 
            default: false
        },
        administrasi: {
            type: Boolean, 
            default: false
        },
        bobotTeknis: {
            type: Boolean, 
            default: false
        },
        passingGrade: {
            type: Boolean, 
            default: false
        },
        teknis: {
            type: Boolean,
            default: false
        },
        nilaiTeknis: {
            type: Boolean,
            default: false
        },
        bobotBiaya: {
            type: Boolean,
            default: false,
        },
        nilaiPenawaran: {
            type: Boolean, 
            default: false
        },
        biaya: {
            type: Boolean,
            default: false
        },
        nilaiBiaya: {
            type: Boolean,
            default: false
        },
        totalNilai: {
            type: Boolean,
            default: false
        },
        pemenang: {
            type: Boolean, 
            default: false
        },
        readonly: {
            type: Boolean,
            default: false
        },
        vendor: {
            type: Boolean,
            default: false
        },
    },

    data() {
        return {
            listEvaluasi: [],
            bobotHarga: 0,

            // Notification
            notification: {
                show: false,
                color: "",
                text: ""
            },

            submitting: false,
        }
    },
    
    computed: {
        paket() {
            return this.$store.getters['lelang/paket']
        },
    },

    watch: {
        paket() {
            this.getData();
        }
    },

    mounted() {
        this.getData();
    },

    methods: {
        getData() {
            console.log('this.vendor', this.vendor)
            this.listEvaluasi = [];
            
            axios.get(`${apiUrl}/api/lelang/evaluasi/${this.paket.id}`)
            .then( (response) => { 
                let data = response.data;
                if(this.vendor) {
                    console.log('vendooooooor');
                    this.listEvaluasi = data.filter(item => item.urutan !== 0);
                } else {
                    console.log('bukan vendooooooor');
                    this.listEvaluasi = data;
                }
                console.log('this.listEvaluasi', this.listEvaluasi)
            })
            .catch( (error) => { 
                console.error(error); 
            }); 
        },

        getNilaiTeknis(evaluasi) {


            if(this.paket.metodeEvaluasi == 'NILPSG') {
                if(evaluasi.hasilTeknis < this.paket.passingGrade) {
                    return 0;
                }
                else {
                    return this.paket.bobotTeknis / 100.0 * evaluasi.hasilTeknis;
                }
            }else if(this.paket.metodeEvaluasi == 'RENPSG') {
                if(evaluasi.hasilTeknis < this.paket.passingGrade) {
                    return 0;
                }
                else { 
                    return evaluasi.hasilTeknis * 1;
                }
            } else if(this.paket.metodeEvaluasi == 'REN') {
                return evaluasi.hasilTeknis * 1;
            } else {
                return this.paket.bobotTeknis / 100.0 * evaluasi.hasilTeknis;
            }


        },

        getNilaiBiaya(evaluasi) {
            
            if(this.paket.metodeEvaluasi == 'REN' || this.paket.metodeEvaluasi == 'RENPSG') {
                return evaluasi.hasilHarga * 1;
            } else {
                return this.paket.bobotHarga / 100.0 * evaluasi.hasilHarga;
            }
            
        },

        getTotalNilai(evaluasi) {
            
            evaluasi.totalNilai = this.getNilaiTeknis(evaluasi) + this.getNilaiBiaya(evaluasi);
            return evaluasi.totalNilai;

        },

        simpanEvaluasi() {
            this.submitting = true;

            const fdata = {
                paketPenyediaId: this.paket.id,
                listEvaluasi: this.listEvaluasi,
                dokumenKualifikasi: this.dokumenKualifikasi,
                kualifikasi: this.kualifikasi,
                administrasi: this.administrasi,
                teknis: this.teknis,
                harga: this.biaya || this.nilaiPenawaran,
                pemenang: this.pemenang
            };

            axios.put(`${apiUrl}/api/lelang/evaluasi`, fdata)
            .then( () => {
                //console.log(response)
                this.notification = {
                    show: true,
                    color: "success",
                    text: "Evaluasi vendor berhasil disimpan"
                }
            })
            .catch( (error) => {
                this.notification = {
                    show: true,
                    color: "error",
                    text: `[${error.message}] Gagal simpan evaluasi vendor`
                };
            })
            .finally( () => {
                this.submitting = false;
            });
        },
    }
}
</script>

<style scoped>
.container{
  max-width: 100vw;
  padding:0px;
}
</style>
